<template>
    <div class="land-promo">
        <div class="land-page-carousel">
            <swiper :options="swiperOption" ref="LandPromoCarousel">
                <swiper-slide v-for="(slide, index) in salesCard.project_land_site.land_gallery" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <div class="promo-carousel-in">
                <div class="container">
                    <div class="promo-header">
                        <div class="promo-logo">
                            <img :src="salesCard.logo_white">
                        </div>
                        <!-- <div class="promo-right-column">
                            <div class="favorite" v-if="salesCardPage != null && salesCardPage.land_site_btns != null && salesCard != null">
                                <svg-icon icon-class="star" className="icon-star"/>
                                <a href="#" download>{{salesCardPage.land_site_btns.favorite}}</a>
                            </div>
                        </div> -->
                    </div>
                    <div class="promo-title">
                        <h2>{{salesCard.project_title}}</h2>
                    </div>
                    <div class="promo-land-btns" v-if="salesCardPage != null && salesCardPage.land_site_btns != null && salesCard != null">
                        <div class="flats" v-if="salesCard != null && salesCard.project_land_site.flats_init == 'true'">
                            <a href="#"  v-scroll-to="{
                                el: '#land-flats',
                                offset: -100
                            }">{{salesCardPage.land_site_btns.flats}}</a>
                        </div>
                        <div class="present">
                            <!-- <svg-icon icon-class="donwload" className="icon icon-download"/> -->
                            <a :href="salesCard.project_land_site.land_present_file" download target="_blank">{{salesCardPage.land_site_btns.present}}</a>
                        </div>
                    </div>
                    <div class="swiper-controls sales-land-controls" v-if="salesCard.project_land_site.land_gallery != undefined && salesCard.project_land_site.land_gallery.length > 1">
                        <div class="container">
                            <div class="sales-land-btn-prev slider-btn">
                                <svg-icon icon-class="left-arrow" className="icon icon-arrow-left"/>
                            </div>
                            <div class="sales-land-btn-next slider-btn">
                                <svg-icon icon-class="right-arrow" className="icon icon-arrow-right"/>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination sales-land-pagination" v-if="salesCard.project_land_site.land_gallery != undefined && salesCard.project_land_site.land_gallery.length > 1"></div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-promo',
        props: ['cityProject'],
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cardID: this.$route.params.id,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.sales-land-btn-next',
                        prevEl: '.sales-land-btn-prev',
                    },
                    pagination: {
                        el: '.sales-land-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-promo.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-promo-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>